/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PeriodResponse } from '../../models/period-response';
import { UpdatePeriodRequest } from '../../models/update-period-request';

export interface UpdatePeriod$Params {
  id: string;
      body: UpdatePeriodRequest
}

export function updatePeriod(http: HttpClient, rootUrl: string, params: UpdatePeriod$Params, context?: HttpContext): Observable<StrictHttpResponse<PeriodResponse>> {
  const rb = new RequestBuilder(rootUrl, updatePeriod.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PeriodResponse>;
    })
  );
}

updatePeriod.PATH = '/v0/explore-graph/periods/{id}';
